import React from 'react';
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import BizLocationtForm from "../component/BizLocation/BizLocationtForm";

class BizLocationFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de Locais" to="/list/biz-locations"/>,
      <BreadcrumbItem key={3} title="Dados do Local" active={true}/>];
    return (
        <Page title="Dados do Local" breadcrumbs={breadcrumbs}>
          <BizLocationtForm match={match} history={history}/>
        </Page>
    );
  }
}

export default BizLocationFormPage;



// WEBPACK FOOTER //
// ./src/bizLocation/BizLocationFormPage.js